<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'FiltrosPesquisaPlacas',
  props: { 
    buscarFiltro: Function
  },
  data () {
    return {
      validacao: false,
      isMobile: isMobile,
      showCollapse: false,
      selectedPeriodo: "P",
      optionsPeriodo: [{
        value: "P",
        text: "Período do Dia"
      }, {
        value: "D",
        text: "Por Dia"
      }],
      placa: "",
      placaPosicaoNValido: [],
      selectedFaixas: [1, 2, 3, 4, 0],
      optionsFaixas: [
        { value: 1, text: "Faixa 1" },
        { value: 2, text: "Faixa 2" }, 
        { value: 3, text: "Faixa 3" }, 
        { value: 4, text: "Faixa 4" }
      ],
      allSelected: false,
      indeterminate: false,
      selectedPontos: [],
      selectedTipo: "P",
      optionsTipo: [
        { value: "P", text: "Posição" },
        { value: "E", text: "Equivalente" }
      ],
      dateInicial: new Date,
      dateFinal: new Date,
      horaInicial: '07:00:00',
      horaFinal: '17:59:59',
      optionsDateInicial: {
        format: "DD/MM/YYYY",
        useCurrent: true,
        ignoreReadonly: true
      },
      optionsDateFinal: {
        format: "DD/MM/YYYY",
        useCurrent: true,
        ignoreReadonly: false
      },
      optionsHora: {
        format: "HH:mm:ss",
        useCurrent: true,
        ignoreReadonly: false
      }
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo,
      radares: state => state.modulePesquisa.buscaradar,
      pp: state => state.modulePesquisa.buscarpesquisaplacas,
      pagesize: state => state.modulePesquisa.pagesize
    }),  
    nomeIcone() {
      return this.showCollapse ? 'chevron-up' : 'chevron-down'
    }
  },
  methods: {
    formatarPlaca (e) {
        return e.toUpperCase()
    },
    toggleAll (e) {
      var t = this;
      this.selectedPontos = e ? Object.keys(this.radares).map((function(e) { return t.radares[e].value})) : []
    },
    pesquisarClick () {
      var e = [...this.placa]
      this.pp.L1 = this.preechendoPlaca(e[0])
      this.pp.L2 = this.preechendoPlaca(e[1])
      this.pp.L3 = this.preechendoPlaca(e[2])
      this.pp.N1 = this.preechendoPlaca(e[3])
      this.pp.N2 = this.preechendoPlaca(e[4])
      this.pp.N3 = this.preechendoPlaca(e[5])
      this.pp.N4 = this.preechendoPlaca(e[6])
      this.pp.strDateInicial = this.dateInicial
      this.pp.strDateFinal = this.dateFinal
      this.pp.strSelectdPontos = this.selectedPontos.join() 
      this.pp.selecionadoPontos = this.selectedPontos.length > 0 ? true : false
      this.pp.selectedTipo = this.selectedTipo
      if ("D" == this.selectedPeriodo)  {
        this.pp.strHoraInicial = "00:00:00"
        this.pp.strHoraFinal = "23:59:59"
      }else {
        this.pp.strHoraInicial = this.horaInicial
        this.pp.strHoraFinal = this.horaFinal 
      }
      this.$store.state.buscaimagemP = "img/icons/carro.jpg" 
      this.$store.state.buscaimagemZ = "img/icons/carro.jpg"
      this.buscarFiltro(1)
    },
    mudadoDataInicial () {
      this.optionsDateFinal.minDate = this.dateInicial
    },
    mudadoDataFinal () {
      this.optionsDateInicial.maxDate = this.dateFinal
    },
    preechendoPlaca (e) {
      if ("P" == this.selectedTipo)  
        if (undefined == e || " " == e || "_" == e)  
          return "%" 
        else  
          return e 
      else 
        if(undefined == e || " " == e || "%" == e) 
          return "_" 
        else 
          return e
    }
  },
  mounted: function() {
    //this.$store.dispatch("BUSCARADARES", {cidade: "Sarandi"})
    this.$store.dispatch("BUSCARADARES", {cidade: this.user.cidade})
  },
  watch: {
    validacao(){
      if (this.selectedPontos.length == 0)  {
        this.validacao = false
      } else if (this.selectedPontos.length == Object.keys(this.radares).length) {
        this.validacao = true
        this.validacao = 0 == this.placaPosicaoNValido.length
      } else {
        this.validacao = true
        this.validacao = 0 == this.placaPosicaoNValido.length
      }
    },
    placa () {
      if ("" == this.placa) {
        this.validacao = true
        this.pp.placaValido = true
        this.pp.L1 = "%"
        this.pp.L2 = "%"
        this.pp.L3 = "%"
        this.pp.N1 = "%"
        this.pp.N2 = "%"
        this.pp.N3 = "%"
        this.pp.N4 = "%"
      }
      else {
        this.placa = this.placa.toUpperCase()
        this.placaPosicaoNValido = []
        var e = [...this.placa]
        this.pp.L1 = this.preechendoPlaca(e[0])
        !this.pp.L1.match(/^[A-Z|%|_]$/) && this.placaPosicaoNValido.push(1)
        this.pp.L2 = this.preechendoPlaca(e[1])
        !this.pp.L2.match(/^[A-Z|%|_]$/) && this.placaPosicaoNValido.push(2)
        this.pp.L3 = this.preechendoPlaca(e[2])
        !this.pp.L3.match(/^[A-Z|%|_]$/) && this.placaPosicaoNValido.push(3)
        this.pp.N1 = this.preechendoPlaca(e[3])
        !this.pp.N1.match(/^[\d|%|_]$/) && this.placaPosicaoNValido.push(4)
        this.pp.N2 = this.preechendoPlaca(e[4])
        !this.pp.N2.match(/^[A-Z|\d|%|_]$/) && this.placaPosicaoNValido.push(5)
        this.pp.N3 = this.preechendoPlaca(e[5])
        !this.pp.N3.match(/^[\d|%|_]$/) && this.placaPosicaoNValido.push(6)
        this.pp.N4 = this.preechendoPlaca(e[6])
        !this.pp.N4.match(/^[\d|%|_]$/) && this.placaPosicaoNValido.push(7)
        this.pp.placaValido = 0 == this.placaPosicaoNValido.length
        this.validacao = 0 == this.placaPosicaoNValido.length
      }
    },    
    selectedPontos (newValue) {
      var e = newValue
      if (0 == e.length)  {
        this.indeterminate = false
        this.allSelected = false 
        this.validacao = false
      } else if (e.length == Object.keys(this.radares).length) {
        this.indeterminate = false 
        this.allSelected = true
        this.validacao = true
      } else {
        this.indeterminate = true
        this.allSelected = false
        this.validacao = true
      }
    }
  }
}
</script>

<template>
  <b-container class="container">
    <b-row>
      <b-col cols="9" md="12">
        <div class="textoFiltros">Filtros Pesquisa Placas em {{user.cidade}}</div>
      </b-col>
      <b-col>
        <b-button v-b-toggle.collapse-2 class="collapse-button float-right shadow rounded"
          :class="showCollapse ? 'collapsed' : null"
          :aria-expanded="showCollapse ? 'true' : 'false'"
          aria-controls="collapse-4"
          @click="showCollapse = !showCollapse">
          <icon :name="nomeIcone" />
        </b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-2"  visible>
      <b-form-row class="form-pesquisa-filtros">
        <b-col cols=12 md="6">
          <b-row class="text-left" align-v="center">
            <b-col>
              <b-form-text>Periodo:</b-form-text>
              <b-form-radio-group v-model="selectedPeriodo" :options="optionsPeriodo" />
            </b-col>
          </b-row>
          <b-row class="text-left" align-v="center">
            <b-col :cols="isMobile ? 12 : selectedPeriodo == 'P' ? 6 : 12">
              <b-form-text>Data Inicial:</b-form-text>
              <b-form-datepicker class="mb-2 shadow rounded" v-model="dateInicial" :date-format-options="optionsDateInicial" @context="mudadoDataInicial" 
                :max="new Date()" :min="new Date(new Date().getFullYear()-2, new Date().getMonth(), new Date().getDate())" />
            </b-col>
            <b-col :cols="isMobile ? 12 : 6">
              <b-form-text v-show='selectedPeriodo == "P"'>Hora Inicial:</b-form-text>
              <b-form-timepicker class="shadow rounded" v-model="horaInicial" locale="en"
                label-no-time-selected='Selecione um horario' v-show='selectedPeriodo == "P"'>
              </b-form-timepicker>
            </b-col>
          </b-row>
          <b-row class="text-left" align-v="center">
            <b-col :cols="isMobile ? 12 : selectedPeriodo == 'P' ? 6 : 12">
              <b-form-text>Data Final:</b-form-text>
              <b-form-datepicker class="mb-2 shadow rounded" v-model="dateFinal" :date-format-options="optionsDateFinal" @context="mudadoDataFinal"
                :max="new Date()"  :min="dateInicial"/>
            </b-col>
            <b-col :cols="isMobile ? 12 : 6">
              <b-form-text v-show='selectedPeriodo == "P"'>Hora Final:</b-form-text>
              <b-form-timepicker class="shadow rounded" v-model="horaFinal" locale="en"
                label-no-time-selected='Selecione um horario' v-show='selectedPeriodo == "P"'>
              </b-form-timepicker>
            </b-col>
          </b-row>
          <b-row class="text-left" align-v="center">
            <b-col>
              <b-form-text>Tipo de busca:</b-form-text>
              <b-form-radio-group v-model="selectedTipo" :options="optionsTipo"
                name="radioTipo" class="float-left radioTipo" />
            </b-col>
          </b-row>
          <b-row class="text-left" align-v="center">
            <b-col cols="12">
              <b-form-text>Placa:</b-form-text>
              <b-form-input class="shadow rounded"  v-model="placa" 
                :state="pp.placaValido" :formatter="formatarPlaca"
                style="letter-spacing: 5px" maxLength=7 />
              <b-form-invalid-feedback id="inputPlaca"> Placa Invalida na posicao: {{placaPosicaoNValido.join()}} </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-col>
        <!-- segunda coluna -->
        <b-col cols=12 md="6">
          <div class="pontos shadow rounded text-left">
            <b-form-group  align-v="center" v-slot="{ ariaDescribedby }">
              <b class="ml-2">Pontos:</b><br>
              <b-form-checkbox class="ml-2" v-model="allSelected" :indeterminate="indeterminate"
                aria-describedby="flavours" aria-controls="flavours" @change="toggleAll">
                {{ allSelected ? 'Desselecionar' : 'Selecionar todos' }}
              </b-form-checkbox>
              <b-form-checkbox-group id="flavors" class="ml-4" v-model="selectedPontos"
                :options="radares" :aria-describedby="ariaDescribedby"
                name="flavors" aria-label="Individual flavours" stacked />
            </b-form-group>
          </div>
        </b-col>
        <b-col offset="8">
          <b-button class="button-submit float-right shadow rounded" v-b-toggle="'collapse-2'" @click="pesquisarClick" :disabled='!validacao' :variant="validacao ? 'success' : ''">Pesquisar</b-button>
        </b-col>
      </b-form-row>
    </b-collapse>
  </b-container>
</template>

<style>
  .pontos {
    height: 360px !important;
    overflow-y: auto;
  }
  .container {
    background-color: white;
    border-width: .2 rem;
  }

  .collapse-button {
    margin-top: 2px;
    margin-bottom: 2px;
    right:0;
  }

  .textoFiltros {
    font-weight: bold;
    color: #2c3e50;
    left: 0;
    text-align: left;
    padding-top: 1.5vh;
  }

  @media screen and (max-width: 500px){
    .textoLabels {
      color: #2c3e50;
      left: 0;
      text-align: left;
      padding-top: 1.5vh;
    }
    .radioTipo {
      padding-top: 1.5vh;
    }
  }

  @media screen and (min-width: 501px){
    .textoLabels {
      color: #2c3e50;
      left: 0;
      text-align: left;
      padding-top: 0.75vh;
    }

    .radioTipo {
      padding-top: 0.75vh;
    }
  }


  .button-submit {
    right: 0;
    padding-right: 15px !important;
  }

  .form-pesquisa-filtros {
    padding-bottom: 2vh;
  }
</style>
